export const kioskFiltersInitialState = {
  subjectFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'subjectFilter',
    translateKey: 'filter:subject',
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    platform: 'newspaper',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    hasIncludeExclude: false,
    filterType: 'include',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'newspaper',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
};
